$(document).ready(function () {
    $('.accordion').on('click', function () {
        $(this).toggleClass('active');
        $(this).next().slideToggle();
    })

  // get collection
    $('.feed_me_collection').each(function(){
      let ele = $(this)
      let colURL = `/collections/${ele.attr('data-collection')}?view=blogs`

      $.ajax({
          url: colURL,
          type: 'GET',
          success: function(res) {
            ele.append(res)
            ele.find('.heading__blogs_products').text(ele.attr('data-heading'))
            ele.find('.atc_span').text('ADD NOW')
            ele.find('modal-opener .quick-add__submit').text('VIEW')
          }
      });
    })


// get product
    $('.feed_me_product').each(function(){
      let ele = $(this)
      let colURL = `/products/${ele.attr('data-product')}?view=blogs`

      $.ajax({
          url: colURL,
          type: 'GET',
          success: function(res) {
            ele.append(res)
            ele.find('.heading__blogs_products').text(ele.attr('data-heading'))
            ele.find('.atc_span').text('ADD NOW')
            ele.find('modal-opener .quick-add__submit').text('VIEW')
          }
      });
    })


  // get product
    $('.feed_me_products').each(function(){
      let ele = $(this)
      let products = ele.attr('data-products').split(',')
      var requests = [];
      ele.append(`<h3 class="heading__blogs_products">${ele.attr('data-heading')}</h3><ul id="product-grid" class="grid product-grid"><ul>`);

      if(products.length > 1){
        for(let i = 0;i<products.length;i++){
          requests.push($.ajax({
            url: `/products/${products[i]}?view=blogs`,
            method: "GET"
          }));
        }

        $.when.apply($, requests).done(function() {
          var responses = Array.prototype.slice.call(arguments);
          for (var i = 0; i < responses.length; i++) {
            
            var data = responses[i][0];
            ele.find('#product-grid').append(data);
          }
          ele.find('.atc_span').text('ADD NOW')
          ele.find('modal-opener .quick-add__submit').text('VIEW')
        }).fail(function() {
          // At least one of the AJAX requests failed
          console.error("One or more requests failed.");
        });
      }else{
        let colURL = `/products/${products}?view=blogs`

        $.ajax({
            url: colURL,
            type: 'GET',
            success: function(res) {
              ele.find('#product-grid').append(res);
              ele.find('.heading__blogs_products').text(ele.attr('data-heading'))
              ele.find('.atc_span').text('ADD NOW')
              ele.find('modal-opener .quick-add__submit').text('VIEW')
            }
        });
      }
      

      
      
    })
  
})